module.exports = __webpack_public_path__ + "assets/img/login_banner_cn_2.dd8b0d32.jpg";